import { Link } from "react-router-dom";

const stats = [
  { value: "18", label: "示例影片资料", icon: "ri-film-line" },
  { value: "6", label: "主题分类片单", icon: "ri-layout-grid-line" },
  { value: "5", label: "导演专题脉络", icon: "ri-clapperboard-line" },
  { value: "100%", label: "剧情介绍可读", icon: "ri-book-open-line" },
];

export default function SiteIntro() {
  return (
    <section className="grain-bg relative w-full overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -left-40 top-10 h-[420px] w-[420px] rounded-full bg-primary-500/20 blur-3xl" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-[360px] w-[360px] rounded-full bg-accent-500/10 blur-3xl" />
      <div className="relative mx-auto grid w-full max-w-[1440px] grid-cols-1 gap-10 px-4 py-16 md:px-8 md:py-20 lg:grid-cols-[0.95fr_1.05fr] lg:gap-16 lg:px-12">
        <div>
          <p className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-500">About the archive</p>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[34px] md:leading-[1.25]">
            一个不催你点播放的
            <br className="hidden md:block" />
            三级片资料库
          </h2>
          <p className="mt-5 max-w-xl font-body text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            我们把注意力放在「查资料」这件事上：这部片讲了什么、谁拍的、属于哪个年代、和哪些作品是同一条线索。
            所有影片都配有结构化剧情介绍、基本信息与同类推荐，你可以先读完再决定要不要找来看。
          </p>
          <p className="mt-4 max-w-xl font-body text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            站点不提供播放、下载与任何交易入口，也不收集账号信息。内容为虚构示例，仅用于展示影视资料站的浏览体验。
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="flex h-10 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 font-label text-sm text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-500"
            >
              了解站点定位
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/search"
              className="flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 font-label text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-search-line" />
              搜索一部片子
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className="flex animate-rise flex-col justify-between gap-6 rounded-lg border border-background-300 bg-background-100 p-5"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/15 text-accent-500">
                <i className={`${stat.icon} text-base`} />
              </span>
              <div>
                <p className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">{stat.value}</p>
                <p className="mt-1 font-label text-xs text-foreground-500">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}